import styled from "@emotion/styled";

import { SchedulePeriodDisplay } from "@/components";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { ScheduleResponseDto } from "@shared/generated/api/model";

interface CourseInfoProps {
  schedule: ScheduleResponseDto;
}

export const CourseInfo = ({ schedule }: CourseInfoProps) => {
  const { t } = useCustomTranslation();
  const isSingleCourse = schedule.cycle.course.type === "SINGLE";

  return (
    <CourseInfoContainer>
      <Title>
        {`${isSingleCourse ? `[${t("one_day")}]` : `[${t("multiple_sessions")}]`} ${schedule.cycle.course.title}`}
      </Title>
      <SchedulePeriodDisplay
        cycleStartsAt={schedule.cycle.startsAt}
        cycleEndsAt={schedule.cycle.endsAt}
        totalSessions={schedule.cycle.course.totalSessions}
        scheduleStartsAt={schedule.startsAt}
        scheduleEndsAt={schedule.endsAt}
        durationPerSession={schedule.cycle.course.durationPerSession}
        sessionNumber={schedule.sessionNumber}
        size="small"
      />
    </CourseInfoContainer>
  );
};

const CourseInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  justify-content: space-between;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.4px;
  text-align: left;
  margin: 0;
`;
